module.exports = __webpack_public_path__ + "img/logo.58b57af4.png";